import { motion } from "framer-motion";
import { useLocale } from "../i18n/LocaleContext";

export function ContactSection() {
  const { copy, locale } = useLocale();
  const { contact } = copy;
  const isChinese = locale === "zh" || locale === "vi";

  return (
    <section id="contact" className="px-5 pb-24 pt-12 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="overflow-hidden rounded-[3.05rem] border border-[#d9e6ec] bg-[radial-gradient(circle_at_top_left,rgba(149,196,210,0.12),transparent_24%),linear-gradient(135deg,rgba(250,253,255,0.96),rgba(239,246,249,0.97)_56%,rgba(230,240,244,0.99))] p-7 shadow-[0_16px_30px_rgba(106,138,151,0.07)] backdrop-blur sm:p-10 lg:p-12"
        >
          <div className="grid gap-10 lg:grid-cols-[0.86fr_1.14fr] lg:items-end lg:gap-12">
            <div>
              <p className="text-[0.72rem] uppercase tracking-[0.44em] text-aurora/78">{contact.eyebrow}</p>
              <h2
                className={`mt-4 max-w-3xl text-[#1f2b31] ${
                  isChinese
                    ? "font-sans text-[2.05rem] font-medium tracking-[-0.01em] sm:text-[2.85rem]"
                    : "font-display text-[2.35rem] font-semibold sm:text-[4rem]"
                }`}
              >
                {contact.title}
              </h2>
              <p className="mt-6 max-w-[14.5rem] text-[0.88rem] leading-7 text-soft/54">{contact.body}</p>

              <div className="mt-9 flex flex-wrap gap-3">
                <a
                  href="mailto:service@qiandu.group?subject=QIANDU%20Partnership%20Inquiry"
                  className="rounded-full bg-[linear-gradient(135deg,#86acba,#9dc5cf)] px-6 py-3.5 text-[10px] uppercase tracking-[0.28em] text-white shadow-[0_10px_22px_rgba(123,167,184,0.2)] transition hover:-translate-y-0.5"
                >
                  {contact.start}
                </a>
              </div>
            </div>

            <div className="space-y-4">
              <div className="overflow-hidden rounded-[2.3rem] bg-[linear-gradient(180deg,rgba(252,254,255,0.82),rgba(240,246,249,0.9))] p-3 shadow-[0_14px_26px_rgba(106,138,151,0.07)]">
                <img
                  src="/official-brands/roundlab-banner.png"
                  alt="QIANDU contact visual"
                  className="h-48 w-full rounded-[1.7rem] bg-[rgba(247,250,251,0.94)] object-contain p-4 sm:h-52 sm:p-5"
                />
              </div>
              <div className="rounded-[2.45rem] bg-[linear-gradient(180deg,rgba(252,254,255,0.82),rgba(240,246,249,0.9))] p-5 shadow-[0_12px_22px_rgba(106,138,151,0.06)] sm:p-6">
                <div className="text-[10px] uppercase tracking-[0.32em] text-soft/50">{contact.directReach}</div>
                <a
                  href="mailto:service@qiandu.group"
                  className={`mt-4 block break-all text-[#1f2b31] transition hover:text-[#7fa7b4] sm:text-[1.58rem] ${
                    isChinese ? "font-sans text-[1.18rem] font-medium" : "font-display text-[1.3rem]"
                  }`}
                >
                  service@qiandu.group
                </a>
                <div className="mt-6 space-y-4">
                  {contact.facts.map((fact) => (
                    <div key={fact.label} className="border-b border-[#dbe8ef] pb-4 last:border-b-0 last:pb-0">
                      <div className="text-[8px] uppercase tracking-[0.34em] text-soft/46">{fact.label}</div>
                      <div className="mt-2 text-[0.92rem] text-[#314047]">{fact.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
